import { ObjectHelpers } from "../../helpers/object-helpers";

export class FindIndicatorDataResultModel {
    public name = '';
    public value = 0;
    public color = '';

    constructor(data?: any) {
        if (data) {
            ObjectHelpers.setProperties(data, this, true);
        }
    }
}